var map = {
	"./Forward.png": "23b9",
	"./Forward@2x.png": "2e70",
	"./Forward@3x.png": "a58b",
	"./NEAR.png": "69f1",
	"./NEAR.svg": "2afb",
	"./NEAR@2x.png": "10c1",
	"./NEAR@3x.png": "0ffb",
	"./activity.png": "75f9",
	"./activity.svg": "8dd6",
	"./activity@2x.png": "10f2",
	"./activity@3x.png": "0557",
	"./add.png": "6e90",
	"./add.svg": "76a4",
	"./add@2x.png": "ac74",
	"./add@3x.png": "b139",
	"./archive.png": "bdbc",
	"./archive.svg": "8238",
	"./archive@2x.png": "3329",
	"./archive@3x.png": "c308",
	"./arrow-down.svg": "c874",
	"./back arrow.png": "abe6",
	"./back arrow.svg": "7bbe",
	"./back arrow@2x.png": "b407",
	"./back arrow@3x.png": "df0b",
	"./back-arrow.png": "171c",
	"./back-arrow.svg": "85f2",
	"./back-arrow@2x.png": "d45c",
	"./back.png": "0142",
	"./back.svg": "7338",
	"./back@2x.png": "a816",
	"./backward.png": "efe7",
	"./backward.svg": "1412",
	"./backward@2x.png": "9ea3",
	"./backward@3x.png": "f31c",
	"./boilerplate-commission.png": "593f",
	"./boilerplate-commission.svg": "65b5",
	"./boilerplate-commission@2x.png": "33c2",
	"./boilerplate-commission@3x.png": "9db1",
	"./browse files.png": "77dc",
	"./browse files.svg": "ef44",
	"./browse files@2x.png": "8449",
	"./browse files@3x.png": "ad80",
	"./calendar.png": "6c68",
	"./calendar.svg": "b8bd",
	"./calendar@2x.png": "8ac0",
	"./calendar@3x.png": "0d30",
	"./campaign.png": "7a4a",
	"./campaign.svg": "8872",
	"./campaign@2x.png": "9ab7",
	"./campaign@3x.png": "fb0e",
	"./check-icon.svg": "fdfe",
	"./check.svg": "7bae",
	"./clock-icon.svg": "e315",
	"./close-drawer.png": "9578",
	"./close-drawer.svg": "6e9b",
	"./close-drawer@2x.png": "19f5",
	"./close-drawer@3x.png": "7284",
	"./close.png": "c821",
	"./close.svg": "8b1b",
	"./close@2x.png": "51f2",
	"./close@3x.png": "f7d9",
	"./coinbasewallet.png": "ee53",
	"./coinbasewallet.svg": "cd36",
	"./coinbasewallet@2x.png": "4f96",
	"./coinbasewallet@3x.png": "a3e8",
	"./collection.png": "46a3",
	"./collection.svg": "3539",
	"./collection@2x.png": "90f6",
	"./collection@3x.png": "2b0e4",
	"./commission.png": "6cf2",
	"./commission.svg": "ee4b",
	"./commission@2x.png": "8bbe",
	"./commission@3x.png": "8fb7",
	"./copy.png": "af4f",
	"./copy.svg": "8aac",
	"./copy@2x.png": "8297",
	"./copy@3x.png": "46c7",
	"./default.png": "3b63",
	"./default.svg": "b5c3",
	"./default@2x.png": "f200",
	"./default@3x.png": "9531",
	"./discord.svg": "e3a3",
	"./dollar.svg": "ae9c",
	"./down.png": "bd05",
	"./down.svg": "d8aa",
	"./down@2x.png": "bcf9",
	"./down@3x.png": "edba",
	"./edit.png": "0f8f",
	"./edit.svg": "daf0",
	"./edit@2x.png": "8796",
	"./edit@3x.png": "248e",
	"./email.svg": "43be",
	"./embargo time.png": "f160",
	"./embargo time.svg": "6f61",
	"./embargo time@2x.png": "81eb",
	"./embargo time@3x.png": "ba8b",
	"./ethereum.png": "b1bc",
	"./ethereum.svg": "0c5f",
	"./ethereum@2x.png": "2b99",
	"./ethereum@3x.png": "382c",
	"./factory.png": "b41d",
	"./factory.svg": "cc7a",
	"./factory@2x.png": "b285",
	"./factory@3x.png": "de7a",
	"./fortmatic.png": "0778",
	"./fortmatic.svg": "d5f9",
	"./fortmatic@2x.png": "5384",
	"./fortmatic@3x.png": "3e60",
	"./forward.svg": "bdb1",
	"./history.svg": "14e1",
	"./info.png": "e810",
	"./info.svg": "76ed",
	"./info@2x.png": "6834",
	"./info@3x.png": "c10e",
	"./location.png": "3645",
	"./location.svg": "d2eb",
	"./location@2x.png": "beda",
	"./location@3x.png": "c438",
	"./lock-icon.svg": "47d9",
	"./lock.png": "85e6",
	"./lock.svg": "9619",
	"./lock@2x.png": "da03",
	"./lock@3x.png": "b63d",
	"./logout-inverted.svg": "e464",
	"./logout.png": "9678",
	"./logout.svg": "69e3",
	"./logout@2x.png": "8745",
	"./logout@3x.png": "1a09",
	"./logout@3xinverted.png": "ef5b",
	"./medium.svg": "4f40",
	"./menu.png": "597d",
	"./menu.svg": "d17f",
	"./menu@2x.png": "a5c7",
	"./menu@3x.png": "3d14",
	"./metamask.png": "12df",
	"./metamask.svg": "a9b9",
	"./metamask@2x.png": "7f94",
	"./metamask@3x.png": "e8d0",
	"./moonpay.png": "0692",
	"./moonpay.svg": "4ce6",
	"./moonpay@2x.png": "2004",
	"./moonpay@3x.png": "d0ab",
	"./percent.png": "2e0e",
	"./percent.svg": "58c8",
	"./percent@2x.png": "d4d6",
	"./percent@3x.png": "02bb",
	"./portis.png": "9f4c",
	"./portis.svg": "977c",
	"./portis@2x.png": "b664",
	"./portis@3x.png": "afaf",
	"./profile.png": "4947",
	"./profile.svg": "95dc",
	"./profile@2x.png": "d419",
	"./profile@3x.png": "868c",
	"./qr code.png": "8074",
	"./qr code.svg": "feeb",
	"./qr code@2x.png": "4cf2",
	"./qr code@3x.png": "4513",
	"./receive-icon.svg": "b483",
	"./recenter.png": "eae1",
	"./recenter.svg": "2226",
	"./recenter@2x.png": "c115",
	"./recenter@3x.png": "9fce",
	"./rejected.svg": "475f",
	"./save.png": "c9ee",
	"./save.svg": "9344",
	"./save@2x.png": "f6b0",
	"./save@3x.png": "76d1",
	"./search.png": "ccef",
	"./search.svg": "d103",
	"./search@2x.png": "867c",
	"./search@3x.png": "2011",
	"./send-icon.svg": "66db",
	"./settings.png": "704c",
	"./settings.svg": "9174",
	"./settings@2x.png": "9d45",
	"./settings@3x.png": "1b4d",
	"./stopwatch.svg": "aac5",
	"./template-art.png": "db8d",
	"./template-art.svg": "f505",
	"./template-art@2x.png": "6d6d",
	"./template-art@3x.png": "6062",
	"./template-music.png": "5b0a",
	"./template-music.svg": "bb33",
	"./template-music@2x.png": "9942",
	"./template-music@3x.png": "0e41",
	"./template-trading-cards.png": "bcc8",
	"./template-trading-cards.svg": "5715",
	"./template-trading-cards@2x.png": "3e58",
	"./template-trading-cards@3x.png": "293a",
	"./torus.png": "5531",
	"./torus.svg": "2a0f",
	"./torus@2x.png": "bd7d",
	"./torus@3x.png": "d2b7",
	"./transaction rejected.png": "f2bf",
	"./transaction rejected.svg": "47bb",
	"./transaction rejected@2x.png": "63f4",
	"./transaction rejected@3x.png": "fbd3",
	"./transaction sent.png": "141a",
	"./transaction sent.svg": "ccfd",
	"./transaction sent@2x.png": "71ec",
	"./transaction sent@3x.png": "ddc4",
	"./transaction succeeded.png": "1b59",
	"./transaction succeeded.svg": "8576",
	"./transaction succeeded@2x.png": "27c7",
	"./transaction succeeded@3x.png": "ead7",
	"./unlock.png": "44c7",
	"./unlock.svg": "d901",
	"./unlock@2x.png": "98c5",
	"./unlock@3x.png": "4110",
	"./up.png": "9c9e",
	"./up.svg": "5c5b",
	"./up@2x.png": "8c13",
	"./up@3x.png": "5e7a",
	"./verify.png": "8533",
	"./verify.svg": "945e",
	"./verify@2x.png": "05cf",
	"./verify@3x.png": "0288",
	"./view.png": "dde4",
	"./view.svg": "00ed",
	"./view@2x.png": "6968",
	"./view@3x.png": "6700",
	"./wallet.png": "8465",
	"./wallet.svg": "4f4a",
	"./wallet@2x.png": "63e5",
	"./wallet@3x.png": "f9fa",
	"./walletconnect.png": "dd74",
	"./walletconnect.svg": "c57c",
	"./walletconnect@2x.png": "17d4",
	"./walletconnect@3x.png": "e2dd",
	"./webgl-indicator.svg": "d424"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";